import { useState } from "react";

const MIN_ZOOM = 0.5;
const MAX_ZOOM = 3;
const ZOOM_STEP = 0.25;

export const usePdfZoom = () => {
  const [zoom, setZoom] = useState(1);

  return {
    zoom,
    zoomPercent: Math.round(zoom * 100),
    canZoomIn: zoom < MAX_ZOOM,
    canZoomOut: zoom > MIN_ZOOM,
    zoomIn: () => setZoom((current) => Math.min(MAX_ZOOM, current + ZOOM_STEP)),
    zoomOut: () => setZoom((current) => Math.max(MIN_ZOOM, current - ZOOM_STEP)),
    resetZoom: () => setZoom(1),
  };
};
